import { deviceSpecificSettings } from './utils';

const spacingCriteria = {
  margin: '',
  padding: '',
};

const blockSpacingAttributes = {
  spacingTop: {
    type: 'object',
    default: deviceSpecificSettings(spacingCriteria),
  },
  spacingBottom: {
    type: 'object',
    default: deviceSpecificSettings(spacingCriteria),
  },
};

export default blockSpacingAttributes;
